import { ref, type Ref } from 'vue';
import type { Toast } from '@components/Toast/Toast';
import { ToastTypes, type ToastType } from '@components/Toast/ToastTypes';

const toasts: Ref<Toast[]> = ref([]);
const toastId = ref(0);

export const useToast = () => {
    const addToast = (message: string, type: ToastType = ToastTypes.Info, duration = 3000) => {
        toastId.value++;
        const id = toastId.value;
        const toast: Toast = {
            id,
            message,
            type,
            duration
        };

        toasts.value.push(toast);

        setTimeout(() => {
            removeToast(id);
        }, duration);
    };

    const removeToast = (id: number) => {
        toasts.value = toasts.value.filter((toast) => toast.id !== id);
    };

    return {
        toasts,
        addToast,
        removeToast
    };
};
